"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VariantsCarousel = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const CarouselWrapper = app_1.styled.div `
  position: relative;
  width: 100%;
  padding-top: 6rem;
  @media ${app_1.notDesktop} {
    padding-top: 3rem;
  }
  // main carousel
  > div > div:first-of-type {
    height: 25rem;
    > div {
      height: 100%;
    }
    @media ${app_1.notDesktop} {
      height: 15rem;
    }
  }
`;
const ClearButton = app_1.styled.button `
  all: unset;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
const InnerCarouselWrap = app_1.styled.div `
  padding: 2rem;
  height: 10rem;
  > div {
    height: 100%;
    > div {
      height: 100%;
    }
  }
`;
function VariantsCarousel({ className, variants, render, loading, }) {
    if (loading) {
        return (0, jsx_runtime_1.jsx)(ui_1.Loading, {});
    }
    return ((0, jsx_runtime_1.jsx)(CarouselWrapper, Object.assign({ className: className }, { children: (0, jsx_runtime_1.jsx)(ui_1.CarouselKeen, { options: {
                slides: {
                    perView: 1,
                    spacing: 20,
                },
            }, render: render, data: variants, hideArrows: true, enhance: ({ children, goToIndex }) => ((0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical" }, { children: [children, (0, jsx_runtime_1.jsx)(InnerCarouselWrap, { children: (0, jsx_runtime_1.jsx)(ui_1.CarouselKeen, { data: variants, render: (data, idx) => ((0, jsx_runtime_1.jsx)(ClearButton, Object.assign({ onClick: () => goToIndex(idx) }, { children: render(data) }))), options: {
                                slides: { perView: 5, spacing: 25 },
                                defaultAnimation: {
                                    duration: 500,
                                },
                                loop: false,
                                drag: true,
                                noAutoSwitch: true,
                                breakpoints: {
                                    [app_1.notDesktop]: {
                                        slides: { perView: 2 },
                                    },
                                },
                            } }) })] }))) }) })));
}
exports.VariantsCarousel = VariantsCarousel;
